import { render, staticRenderFns } from "./ReturnedPackages.vue?vue&type=template&id=673fb439&"
import script from "./ReturnedPackages.vue?vue&type=script&lang=js&"
export * from "./ReturnedPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports